import React from 'react';
import {pianoBank, guitarBank} from './notesBank.js'

export default function Soundbank(props){
    return (
        <div className="soundbank-container" >
            <div className="piano"  onClick={() => props.handleBank(pianoBank, "Piano")}>
                <div className = "piano-button"></div>
                <div>Piano</div>
            </div>
            <div className="guitar" onClick={() => props.handleBank(guitarBank, "Guitar")}>
                <div className = "guitar-button"></div>
                <div>Guitar</div>
            </div>
        </div>
    )
}